<template>
  <div class="checkbox-cell-container">
    <button
      :class="[
        'notes-btn',
        {
          'has-note': hasNote,
          'always-visible': isAlwaysVisible,
        },
      ]"
      :title="!isSubscribedUser ? 'Доступно при наличии платной подписки' : ''"
      @mouseenter="onMouseEnter"
      @mouseleave="onMouseLeave"
      @click.stop="openNote"
    >
      <PenIcon />
    </button>
    <div
      class="checkbox-container"
      @click="toggleSelect"
      :class="{ children: row.parentId }"
    >
      <div
        class="checkbox-ui"
        :class="{
          checked: isChecked,
          indeterminate: !isChecked && isIndeterminate,
        }"
      >
        <span class="checkmark"></span>
      </div>
    </div>
    <span
      class="icon-container"
      :class="{ expanded: isExpanded }"
      v-if="tableContext.hasChildren(row.id) && !row.parentId"
      @click="toggleExpand"
    >
      <CollapseIcon class="icon" />
    </span>
  </div>
</template>

<script>
import CollapseIcon from "@/assets/icons/table-collapse.svg";
import PenIcon from "@/assets/icons/pen-icon.svg";
import { mapGetters, mapActions } from "vuex";
import { showSubscriptionToast } from "@/services/subscriptionNotification";

export default {
  inject: ["tableContext", "notesApi"],
  name: "CheckboxCell",
  props: {
    row: Object,
  },
  components: { CollapseIcon, PenIcon },

  computed: {
    ...mapGetters("notes", ["notes", "noteWindowHeight"]),
    ...mapGetters("auth", ["authorities"]),
    ...mapGetters("profile", ["profileId"]),
    ...mapGetters("subscriptions", ["subscriptions"]),

    isSubscribedUser() {
      return this.authorities?.includes("ROLE_SUBSCRIBED_USER");
    },

    hasNote() {
      const proposalNumber = this.row?.proposalNumber?.proposalNumber;
      if (!proposalNumber || !this.notes) return false;

      return this.notes.some((note) => note.proposalNumber === proposalNumber);
    },

    isAlwaysVisible() {
      return !this.row?.parentId && this.hasNote;
    },

    isChecked() {
      return this.tableContext.selectedMap?.[this.row.id] === true;
    },
    isIndeterminate() {
      return this.tableContext.selectedMap?.[this.row.id] === "indeterminate";
    },
    isExpanded() {
      return (
        this.tableContext.expandedMap[this.row.id] &&
        this.tableContext.expandedMap[this.row.id] !== "collapsing"
      );
    },
  },

  methods: {
    ...mapActions("subscriptions", ["getSubscriptions"]),

    onMouseEnter(e) {
      if (!this.isSubscribedUser) return;

      if (this.hasNote) {
        this.notesApi.show({
          target: e.currentTarget,
          row: this.row,
          mode: "view",
          noteHeight: this.noteWindowHeight || 163,
        });
      }
    },
    onMouseLeave() {
      if (!this.isSubscribedUser) return;
      this.notesApi.hideHover();
    },
    async openNote(e) {
      if (this.isSubscribedUser) {
        this.notesApi.show({
          target: e.currentTarget,
          row: this.row,
          mode: "edit",
          noteHeight: this.noteWindowHeight || 163,
        });
        return;
      }

      await this.getSubscriptions(this.profileId);
      showSubscriptionToast(this.subscriptions, this.$toast);
    },
    toggleSelect() {
      this.tableContext.toggleSelect(this.row);
    },
    toggleExpand() {
      this.tableContext.toggleExpand(this.row.id);
    },
  },
};
</script>

<style scoped lang="less">
.checkbox-cell-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
  padding-left: 4px;

  &:hover .notes-btn,
  :global(.table-row:hover) .notes-btn,
  :global(tr:hover) .notes-btn {
    opacity: 1;
  }

  .notes-btn {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #bfc2c4;
    transition: color 0.2s ease, opacity 0.2s ease;
    opacity: 0;

    &.always-visible {
      opacity: 1;
    }

    &.has-note {
      color: #3457a3;
    }
  }

  .checkbox-container {
    width: 24px;
    height: 24px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    .checkbox-ui {
      width: 17px;
      height: 17px;
      border: 2px solid #cfd8dd;
      border-radius: 2px;
      position: relative;
      background-color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;

      .checkmark {
        opacity: 0;
      }

      &.checked {
        background-color: #37474f;
        border-color: #37474f;

        .checkmark {
          position: absolute;
          width: 12px;
          height: 7px;
          border-left: 2px solid white;
          border-bottom: 2px solid white;
          transform: rotate(-45deg);
          bottom: 5px;
          opacity: 1;
          transition: opacity 0.2s ease;
        }
      }
      &.indeterminate {
        background-color: #37474f;
        border-color: #37474f;
        .checkmark {
          position: absolute;
          width: 10px;
          bottom: 5.5px;
          border-bottom: 2px solid white;
          opacity: 1;
        }
      }
    }
  }
  .checkbox-container.children {
    margin-left: 28px;
  }

  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(180deg);
    transition: transform 0.3s ease-out;
    will-change: transform;
    cursor: pointer;
    &.expanded {
      transform: rotate(0deg);
    }
  }

  .icon {
    display: block;
  }
}
</style>
